import { render } from "./AsTecnologias.vue?vue&type=template&id=8a17192e&scoped=true"
import script from "./AsTecnologias.vue?vue&type=script&lang=js"
export * from "./AsTecnologias.vue?vue&type=script&lang=js"

import "./AsTecnologias.vue?vue&type=style&index=0&id=8a17192e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a17192e"]])

export default __exports__